module.exports = __webpack_public_path__ + "static/media/ic_charley_chat.30ca29e1.svg";